import {
    useEffect,
    useMemo,
    useState
} from "react";

import {
    useNavigate,
    useParams
} from "react-router-dom";

import API from "../../services/api";

import toast from "react-hot-toast";

function RolePermissions() {

    const { roleId } =
        useParams();

    const navigate =
        useNavigate();

    const [role,
        setRole] =
        useState({});

    const [permissions,
        setPermissions] =
        useState([]);

    const [loading,
        setLoading] =
        useState(true);

    const [saving,
        setSaving] =
        useState(false);

    useEffect(() => {

        loadPermissions();

    }, []);

    const loadPermissions =
        async () => {

            try {

                const res =
                    await API.get(
                        `/permissions/${roleId}`
                    );

                setRole(
                    res.data.role
                );

                setPermissions(
                    res.data.permissions
                );

            } catch (err) {

                console.log(err);

                toast.error(
                    "Failed to load permissions"
                );

            } finally {

                setLoading(false);

            }

        };

    const groupedPermissions =
        useMemo(() => {

            return permissions.reduce(
                (
                    groups,
                    permission
                ) => {

                    if (
                        !groups[
                            permission.module_name
                        ]
                    ) {

                        groups[
                            permission.module_name
                        ] = [];

                    }

                    groups[
                        permission.module_name
                    ].push(
                        permission
                    );

                    return groups;

                },
                {}
            );

        }, [permissions]);

    const togglePermission =
        (id) => {

            setPermissions(
                permissions.map(
                    permission =>
                        permission.id === id
                            ? {
                                ...permission,
                                checked:
                                    permission.checked
                                        ? 0
                                        : 1
                            }
                            : permission
                )
            );

        };

    const toggleModule =
        (module) => {

            const modulePermissions =
                groupedPermissions[
                module
                ];

            const allChecked =
                modulePermissions.every(
                    p => p.checked
                );

            setPermissions(
                permissions.map(
                    permission => {

                        if (
                            permission.module_name !== module
                        )
                            return permission;

                        return {

                            ...permission,

                            checked:
                                allChecked
                                    ? 0
                                    : 1

                        };

                    }
                )
            );

        };

    const savePermissions =
        async () => {

            try {

                setSaving(true);

                const selected =
                    permissions
                        .filter(
                            permission =>
                                permission.checked
                        )
                        .map(
                            permission =>
                                permission.id
                        );

                await API.post(
                    `/permissions/${roleId}`,
                    {
                        permissions:
                            selected
                    }
                );

                toast.success(
                    "Permissions Updated"
                );

                navigate(
                    "/admin/roles"
                );

            } catch (err) {

                console.log(err);

                toast.error(
                    "Failed to save"
                );

            } finally {

                setSaving(false);

            }

        };

    if (loading) {

        return (

            <div className="text-center py-10">

                Loading...

            </div>

        );

    }

    return (

        <div>

            <div
                className="
                flex
                justify-between
                items-center
                mb-6
            "
            >

                <div>

                    <h1
                        className="
                        text-4xl
                        font-bold
                    "
                    >
                        Role Permissions
                    </h1>

                    <p
                        className="
                        text-gray-400
                        mt-2
                    "
                    >
                        {role.role_name}
                    </p>

                </div>

                <button
                    onClick={
                        savePermissions
                    }
                    disabled={
                        saving
                    }
                    className="
                    bg-yellow-500
                    hover:bg-yellow-400
                    text-black
                    px-6
                    py-3
                    rounded-xl
                    font-semibold
                "
                >
                    {
                        saving
                            ? "Saving..."
                            : "Save Permissions"
                    }
                </button>

            </div>

            {

                Object.keys(
                    groupedPermissions
                ).map(
                    module => (

                        <div
                            key={module}
                            className="
                            bg-[#111]
                            rounded-2xl
                            p-6
                            mb-6
                        "
                        >

                            <div
                                className="
                                flex
                                justify-between
                                items-center
                                mb-5
                            "
                            >

                                <h2
                                    className="
                                    text-xl
                                    font-bold
                                    text-yellow-400
                                "
                                >
                                    {module}
                                </h2>

                                <button
                                    onClick={() =>
                                        toggleModule(
                                            module
                                        )
                                    }
                                    className="
                                    text-sm
                                    bg-yellow-500
                                    text-black
                                    px-3
                                    py-1
                                    rounded-lg
                                "
                                >
                                    Select All
                                </button>

                            </div>

                            <div
                                className="
                                grid
                                md:grid-cols-2
                                lg:grid-cols-3
                                gap-4
                            "
                            >

                                {

                                    groupedPermissions[
                                    module
                                    ].map(
                                        permission => (

                                            <label
                                                key={
                                                    permission.id
                                                }
                                                className="
                                                flex
                                                items-center
                                                gap-3
                                                bg-black
                                                rounded-xl
                                                px-4
                                                py-3
                                                cursor-pointer
                                            "
                                            >

                                                <input
                                                    type="checkbox"
                                                    checked={
                                                        permission.checked === 1
                                                    }
                                                    onChange={() =>
                                                        togglePermission(
                                                            permission.id
                                                        )
                                                    }
                                                    className="
                                                    w-5
                                                    h-5
                                                "
                                                />

                                                <span>

                                                    {
                                                        permission.permission_name
                                                    }

                                                </span>

                                            </label>

                                        )
                                    )

                                }

                            </div>

                        </div>

                    )
                )

            }
            <button
                    onClick={
                        savePermissions
                    }
                    disabled={
                        saving
                    }
                    className="
                    bg-yellow-500
                    hover:bg-yellow-400
                    text-black
                    px-6
                    py-3
                    rounded-xl
                    font-semibold
                "
                >
                    {
                        saving
                            ? "Saving..."
                            : "Save Permissions"
                    }
                </button>

        </div>

    );

}

export default RolePermissions;